module.exports = __webpack_public_path__ + "img/bookabout.fd4bf067.svg";